import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { premiumIncludes } from '../data/salesData';
export function PremiumIncludesSection() {
  return <section className="border-b border-[var(--line)] bg-[var(--bg-alt)] py-16 sm:py-20" data-id="element-167" data-mp="3ruvg9x5rb3ja">
      <div className="mx-auto max-w-5xl px-4" data-id="element-168" data-mp="nj0nmkiuy5h">
        <SectionHeading eyebrow="Pilates Business & Protocols" data-id="element-169" data-mp="mhlb5wh3phy">
          Qué incluye Premium
        </SectionHeading>

        <ul className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-170" data-mp="3iw1r2rur9ffr">
          {premiumIncludes.map(item => <li key={item.title} className="flex gap-4 rounded-2xl border border-[var(--line)] bg-[var(--surface)] p-6" data-id="element-171" data-mp="3msxtwu227sm4">
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[var(--rose)]/18" data-id="element-172" data-mp="3dvdsnl475wbi">
                <CheckIcon className="h-4 w-4 text-[var(--rose)]" aria-hidden="true" data-id="element-173" data-mp="1721tcbogw1un" />
              </span>
              <div data-id="element-174" data-mp="1c0v96ar884xz">
                <h3 className="font-semibold text-[var(--text)]" data-id="element-175" data-mp="3i3eye073bkff">
                  {item.title}
                </h3>
                <p className="mt-1 text-sm text-[var(--text-soft)]" data-id="element-176" data-mp="3d5dh9kt85v6l">
                  {item.description}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}